<template>
  <div>
    <div>
      <img style="width: 100%;" src="https://sucai003.oss-cn-qingdao.aliyuncs.com/midong/joinus/1-banner.png">
    </div>
    <!--幂动人专享大礼包-->
    <div class="content-wrapper">
      <el-row>
        <el-col :span="24" class="y-title">
          <span class="title-content">幂动人专享大礼包</span>
          <span class="sub-title">We Are Family</span>
        </el-col>
      </el-row>
      <div class="item-wrapper">
        <el-row type="flex" justify="center" class="welfare-item" v-for="item in welfares.contentItems" :key="item.id">
          <el-col :xs="24" :sm="12" :lg="10" class="img-wrapper">
            <img :src="item.image">
          </el-col>
          <el-col :xs="24" :sm="12" :lg="14" class="text-wrapper">
            <div style="font-size: 20px; font-weight: bold;">{{ item.title }}</div>
            <div class="main-content" v-for="text in item.text"><span style="color: #333333; font-weight: bold;">{{ text.title }}</span>{{ text.content }}</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--人才招聘-->
    <div class="content-wrapper">
      <el-row>
        <el-col :span="24" class="y-title">
          <span class="title-content">人才招聘</span>
          <span class="sub-title">我们共同学习，共同成长</span>
        </el-col>
      </el-row>
      <div class="content-wrapper table-wrapper">
        <el-table
          :data="tableData"
          header-row-class-name="join-table-header"
          style="width: 100%"
          :stripe="true">
          <el-table-column
            prop="position"
            label="职位"
            align="center">
          </el-table-column>
          <el-table-column
            prop="number"
            label="人数"
            align="center">
          </el-table-column>
          <el-table-column
            prop="salary"
            label="薪资"
            align="center">
          </el-table-column>
          <el-table-column
            label="详情"
            width="120">
            <template slot-scope="scope">
              <a class="table-link" target="_blank" :href="getAppUrl(scope.row.id)">
                点击查看
              </a>
            </template>
          </el-table-column>
        </el-table>
        <div class="supplement-wrapper">
          <div v-for="item in supplementData">{{ item }}</div>
          <div style="position: absolute; right: 40px; bottom: 20px;">
            <img style="width: 120px; margin-top: -10px;" src="https://sucai003.oss-cn-qingdao.aliyuncs.com/midong/joinus/wechat_qrcode.jpeg">
            <div style="text-align: center;">微信招聘号</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import YHeadContent from '@/components/y-head-content/y-head-content'
  import YTextImg from '@/components/y-text-img/y-text-img'

  var content3 = [
    {
      'id': 1,
      'image': 'http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/home/content-3-1.png'
    }
  ]

  export default {
    components:{
      YHeadContent,
      YTextImg
    },
    data () {
      return {
          welfares: {
            yTitle: '幂动人专项大礼包',
            contentItems: [
              {
                id: '1',
                image: 'http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/joinus/welfare-1.png',
                title: '财富福利',
                text: [
                  {
                    title: '任性金主：',
                    content: '提供优厚薪资待遇，伯乐奖、项目分红、期权等，享有一年两次调薪机会，年终奖励福利。'
                  },
                  {
                    title: '缤纷福利：',
                    content: '除了营养午餐、24小时零食、每周下午茶水果，每位幂动人都能享受到节日礼品，吃喝玩乐腐败金，周年礼物，生日惊喜。'
                  },
                ]
              },
              {
                id: '2',
                image: 'http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/joinus/welfare-2.png',
                title: '贴心保障',
                text: [
                  {
                    title: '六险一金：',
                    content: '入职即为员工缴纳养老、医疗、工商、失业、生育保险和住房公积金，还享有补充医疗保险和员工意外保险，幂动全力为年轻人"出来嗨"保驾护航。',
                  },
                  {
                    title: '年度体检：',
                    content: '为幂动人提供一年一度的身体健康检查，全面检测大家的身体状况，尽早预防各类健康风险。'
                  },
                ]
              },
              {
                id: '3',
                image: 'http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/joinus/welfare-3.png',
                title: '生活娱乐',
                text: [
                  {
                    title: '娱乐体育：',
                    content: '王者荣耀、读书分享会，志同道合的小伙伴等着你。每周定期组织篮球、跑步活动，除了工作，也要身体棒棒哒！',
                  },
                  {
                    title: '溜溜假日：',
                    content: '周末双休、法定节假日休息，享有婚假、产假陪产假及带薪年假、带薪病假。除此之外，每年举行1—3次公司旅游。'
                  },
                ]
              },
              {
                id: '4',
                image: 'http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/joinus/welfare-4.png',
                title: '人才发展',
                text: [
                  {
                    title: '学习培训：',
                    content: '定期开展各类课程和培训，助力员工成长。为幂动培养优秀人才，为幂动成长与业务发展保驾护航。',
                  },
                  {
                    title: '职业发展：',
                    content: '幂动有完善的职业发展体系，每年两次的职级晋升机会，让每一位员工对自己今后的职业发展有更清晰的定位和方向，帮助员工确定更能发挥其能力特长的发展方向。'
                  },
                ]
              }
            ]
          },
          tableData: [
              {
                id: '10',
                position: '产品运营',
                number: '1人',
                salary: '15K - 30K'
              },
              {
                id: '1',
                position: '产品经理',
                number: '1人',
                salary: '15K - 30K'
              },
              {
                id: '2',
                position: '商务',
                number: '2-3人',
                salary: '10K - 20K'
              },
              {
                id: '3',
                position: '广告平台媒介',
                number: '1人',
                salary: '8K - 15K'
              },
              {
                id: '4',
                position: '品牌策划执行',
                number: '1人',
                salary: '7K - 13K'
              },
              {
                id: '5',
                position: '后端广告算法工程师',
                number: '1人',
                salary: '20K - 30K'
              },
              {
                id: '6',
                position: 'JAVA开发工程师',
                number: '2-3人',
                salary: '10K - 20K'
              },
              {
                id: '7',
                position: 'PHP开发工程师',
                number: '1人',
                salary: '9K - 18K'
              },
              {
                id: '8',
                position: 'Android／IOS开发工程师',
                number: '1人',
                salary: '18K - 30K'
              },
              {
                id: '9',
                position: '系统测试工程师',
                number: '1人',
                salary: '8K - 15K'
              },
          ],
          supplementData: [
            '1、一经录用即签订正式劳动合同，五险一金，商业保险，周末双休，中午包餐；',
            '2、一年两次调薪机会，优秀的您还可以拥有公司的股权；',
            '3、每年享受带薪年假、带薪病假、员工年度旅游、员工年度体检、员工生日会等丰富等员工活动；',
            '4、广阔的职业提升空间，公平的晋升机制，完整的职前培训和在职培训；',
            '5、公司处在高速发展阶段，所有员工享受公平晋升平台，能力决定薪资，实力决定岗位；',
            '简历投递邮箱：hr@midongtech.cn',
            '公司地址：广州市海珠区聚德路223号聚德园D栋3楼',
          ],
      }
    },
    methods: {
      getAppUrl (id) {
        return `${window.location.origin}/joinusrecruit?recruitid=${id}`;
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import "../../commons/style/index.scss";

  .item-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .welfare-item {
    @media (max-width: 768px) {
      width: 100%;
      flex-direction: column;
    }
    @media (min-width: 1200px) {
      width: 1200px;
    }
    margin-bottom: 60px;
    padding: 10px;
    .img-wrapper {
      text-align: right;
      padding-right: 20px;
      img {
        width: 300px;
      }
    }
    .text-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      color: #333333;
      font-size: 16px;
      line-height: 30px;
      padding: 0px 20px;
    }
  }

  .content-wrapper {
    padding: 20px;
    margin: 0px auto;
    @media (min-width: 768px) {
      width: 100%;
    }
    @media (min-width: 1200px) {
      width: 1200px;
    }
  }

  .table-wrapper {
    padding: 60px 20px;
    margin: 0px auto;
    @media (min-width: 768px) {
      width: 80%;
    }
    @media (min-width: 1200px) {
      width: 1000px;
    }
    .table-link {
      text-decoration: none;
      color: #6292ad;
      img {
        height: 10px;
        vertical-align: middle;
      }
    }
  }

  .supplement-wrapper {
    background-color: #60aff1;
    color: #ffffff;
    line-height: 36px;
    padding: 20px;
    letter-spacing: 2px;
    position: relative;
  }
</style>

<style lang="scss" rel="stylesheet/scss">
  .join-table-header th {
    background-color: #60aff1 !important;
    color: #ffffff;
    height: 40px;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/joinus/joinus.vue